import React from 'react';
import PropTypes from 'prop-types';
import VideoPlayer from '../../../VideoPlayer';
import AdjustableModal from '../../../AdjustableModal/AdjustableModal';

const ReadToMeModal = ({ readToMeModalClose, book, isReadToMeVideoPlay }) => {
    return (
        <AdjustableModal onClose={readToMeModalClose}>
            <VideoPlayer
                name={book.readAlouds[0].filename}
                videoSrc={book.readAlouds[0].url}
                videoPlay={isReadToMeVideoPlay}
            />
        </AdjustableModal>
    );
};

ReadToMeModal.propTypes = {
    readToMeModalClose: PropTypes.func.isRequired,
    book: PropTypes.shape({
        readAlouds: PropTypes.arrayOf(
            PropTypes.shape({
                filename: PropTypes.string.isRequired,
                url: PropTypes.string.isRequired,
            })
        ).isRequired,
    }).isRequired,
    isReadToMeVideoPlay: PropTypes.bool.isRequired,
};

export default ReadToMeModal;
